import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalsOpen: {},
  callModalOpenId: null
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.modalsOpen[action.payload] = true;
      state.callModalOpenId = action.payload;
    },
    closeModal: (state, action) => {
      delete state.modalsOpen[action.payload];
    },
    setCallModalOpenId: (state, action) => {
      state.callModalOpenId = action.payload;
    }
  },
});

export const { 
  openModal, 
  closeModal,
  setCallModalOpenId
} = modalSlice.actions;

export const selectIsModalOpen = (state, modalId) => state.modal.modalsOpen[modalId];
export const selectCallModalOpenId = (state) => state.modal.callModalOpenId;

export default modalSlice.reducer;
